import {
  Box,
  Button,
  Grid,
  InputLabel,
  TextField,
  Checkbox,
  Card,
  CardContent,
  Autocomplete,
  Tooltip,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { usersApi } from "../../app/slices/usersSlice";
import CustomTable from "./CustomTable";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createMRTColumnHelper } from "material-react-table";
import UseFetch from "../../customComponents/UseFetch";
import { truncateText } from "../../utils/truncateText";
import DateSearchComponent from "./DateSearchComponent";
import { notificationApi } from "../../app/slices/notificationSlice";
import ToastComponent from "./ToastComponent";
import { ContentCopy } from "@mui/icons-material";
import { IoMdOpen } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import Swal from "sweetalert2";
import { FormHelperText } from "@mui/material";
import { useNavigate } from "react-router-dom";
import NotificationTable from "./NotificationTable";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { handleDelete } from "../../utils/handleDelete";
import axiosInstance from "../../utils/axiosInstance";
import { useFileTypeValidator } from "../../utils/fileTypeValidator";

export default function SendNotification() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const baseUrl = import.meta.env.VITE_BASE_URL;
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });

  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };
  const dispatch = useDispatch();

  const sliceResponseNotification = useSelector(
    (state) => state?.notification?.notification?.data
  );
  const stateLoading = useSelector((state) => state.notification.loading);
  useEffect(() => {
    dispatch(notificationApi(queryParams));
  }, [dispatch, queryParams, navigate]);
  const [refresh, setRefresh] = useState(false); // State to control refetch
  const roleResponse = useSelector((state) => state.login.login.role);

  const [sliceResponse] = UseFetch(`${"/user"}`, [refresh]);
  // const [sliceResponse] = UseFetch(`${baseUrl}${"/user"}`, [refresh]);
  const [UsersList, setUsersList] = useState([]);

  useEffect(() => {
    setUsersList(sliceResponse);
  }, [sliceResponse]);

  const [formErrors, setFormErrors] = useState({});
  const [showForm, setShowForm] = useState(true);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    image: null,
    // users: [],   this field changed to customerRefNos
    customerRefNos: [],
    date: "",
    time: "",
    scheduling: "Now", // Default to "Now"
  });
  const maxSize = 5 * 1024 * 1024;
  const allowedExtensions = ["png", "jpg", "webp"];
  const { validatedFile, error: fileError } = useFileTypeValidator(
    formData.image,
    allowedExtensions,
    maxSize
  );
  console.log("formData: ", formData);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // if (type === "file") {
    //   // Handle file input
    //   setFormData((prevData) => ({
    //     ...prevData,
    //     [name]: e.target.files[0],
    //   }));
    // } 
    if (type === "file") {
      const file = e.target.files[0];

      setFormData((prevData) => ({
        ...prevData,
        [name]: file,
      }));
    }
    else if (name === "scheduling") {
      // Handle checkbox for scheduling
      setFormData((prevData) => ({
        ...prevData,
        scheduling: checked ? "Scheduled" : "Now",
      }));
    } else {
      // Handle other form fields
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleUsersChange = (event, newValue) => {
    if (newValue.some((option) => option.name === "Select All")) {
      if (formData.customerRefNos.length === dataForUserSelection.length) {
        // Deselect all
        setFormData((prevData) => ({
          ...prevData,
          customerRefNos: [],
        }));
      } else {
        // Select all
        // const allTokens = dataForUserSelection.map(
        //   (user) => user.fcm_token || ""
        // );
        setFormData((prevData) => ({
          ...prevData,
          // customerRefNos: allTokens,
          customerRefNos: "all",
        }));
      }
    } else {
      // Handle regular selection
      // const tokens = newValue.map((user) => user.fcm_token || "");
      const tokens = newValue.map((user) => user._id || "");
      setFormData((prevData) => ({
        ...prevData,
        customerRefNos: tokens,
      }));
    }
  };

  // Correctly define the arrayOfAllFcm function
  const arrayOfAllFcm = (data) => {
    if (!Array.isArray(data)) return []; // Ensure data is an array before processing
    return data.filter((e) => e?.fcm_token); // Filter out objects with valid fcm_token
  };

  // Prepend "Select All" option to the array

  const dataForUserSelection = [
    { name: "Select All" },
    ...arrayOfAllFcm(UsersList),
  ];
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (fileError) {
      toast.error(fileError);
      return;
    }

    // Validation
    const errors = {};
    if (!formData.title) errors.title = "Title is required";
    // if (!formData.image) errors.image = "Image is required";
    if (!formData.customerRefNos || formData.customerRefNos.length === 0)
      errors.customerRefNos = "At least one user must be selected";
    // if (!formData.description) errors.description = "Description is required";
    // if (!formData.scheduling !== "Now") {
    //   errors.date = "Please select a scheduling Date";
    // }
    // if (!formData.scheduling !== "Now") {
    //   errors.time = "Please select a scheduling Time";
    // }

    setFormErrors(errors);

    if (Object.keys(errors).length > 0) return;

    const url = `/send-notification`;
    // const url = `${baseUrl}/send-notification`;

    const formDataToSend = new FormData();
    formDataToSend.append("title", formData.title);
    formDataToSend.append("scheduling", formData.scheduling);
    formDataToSend.append("time", formData.time);
    formDataToSend.append("date", formData.date);
    formDataToSend.append("body", formData.description);
    if (formData.customerRefNos === "all") {
      formDataToSend.append("customerRefNos", formData.customerRefNos);
    } else {
      formData.customerRefNos.forEach((item) => {
        formDataToSend.append("customerRefNos[]", item);
      });
      // formDataToSend.append(
      //   "customerRefNos",
      //   JSON.stringify(formData.customerRefNos)
      // );
    }
    // formDataToSend.append("tokens", JSON.stringify(formData.customerRefNos));

    if (formData.image) {
      formDataToSend.append("image", formData.image);
    }

    try {
      const response = await axiosInstance.post(url, formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // const response = await axios.post(url, formDataToSend, {
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //     Accept: "application/json",
      //     Authorization: `Bearer ${token}`,
      //   },
      // });

      if (
        response.data.message === "Notification scheduled and saved." ||
        response.data.message === "Notification sent and saved!"
      ) {
        setRefresh(!refresh);
        Swal.fire({
          text: response.data.message,
          icon: "success",
          timer: 3000,
          showConfirmButton: false,
        });
        // toast.success(response.data.message);
        setFormData({
          title: "",
          description: "",
          image: null,
          customerRefNos: [],
          date: "",
          time: "",
          scheduling: "Now",
        });
        dispatch(notificationApi(queryParams));
        setShowForm(true);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };
  // function formatToIST(utc) {
  //   const date = new Date(utc);
  //   console.log("date.toLocaleString", date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }));
  //   return date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
  // }

  function convertUTCToISTParts(utc) {
    const date = new Date(utc);

    const ist = new Date(
      date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
    );

    const yyyy = ist.getFullYear();
    const mm = String(ist.getMonth() + 1).padStart(2, "0");
    const dd = String(ist.getDate()).padStart(2, "0");

    const hh = String(ist.getHours()).padStart(2, "0");
    const min = String(ist.getMinutes()).padStart(2, "0");
    const sec = String(ist.getSeconds()).padStart(2, "0");

    return {
      date: `${yyyy}-${mm}-${dd}`, // YYYY-MM-DD
      time: `${hh}:${min}:${sec}`, // HH:MM:SS
    };
  }

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("title", {
      header: "Title",
      size: 30,
    }),

    columnHelper.accessor("body", {
      header: "Description",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.body);
          toast.success("copied to clipboard!");
        };
        const value = cell.getValue();
        return (
          <>
            <Tooltip title="Copy">
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
            </Tooltip>
            <Tooltip title={value} arrow>
              <span>{truncateText(value, 5)}</span>
            </Tooltip>
          </>
        );
      },
    }),

    columnHelper.accessor("usernames", {
      header: "Users",
      size: 30,
      Cell: (cell) => {
        const usernames = cell.row.original?.usernames || [];

        // Show only the first 2 usernames and add "..." if there are more
        const displayUsernames = usernames?.slice(0, 2).join(", ");
        const truncatedDisplay =
          usernames.length > 2 ? `${displayUsernames}, ...` : displayUsernames;
        const OpenUsersInModal = () => {
          setOpen(true);
          setshowUsersList(usernames);
        };
        return (
          <>
            <Box sx={{ display: "flex", gap: "5px", alignItems: "center" }}>
              <Tooltip title="Show All">
                <IconButton onClick={OpenUsersInModal}>
                  <IoMdOpen fontSize={"1rem"} color="black" />
                </IconButton>
              </Tooltip>

              <Tooltip title={usernames.join(", ")} arrow>
                <span>{truncatedDisplay}</span>
              </Tooltip>
            </Box>
          </>
        );
      },
    }),

    columnHelper.accessor("image", {
      header: "Image",
      size: 30,
      Cell: ({ cell }) => (
        <img
          src={cell?.getValue()}
          alt="Image"
          style={{ width: "50px", height: "50px", objectFit: "cover" }}
        />
      ),
    }),
    // columnHelper.accessor("date", {
    //   header: "Date",
    //   size: 30,
    //   Cell: (cell) => {
    //     const ist = formatToIST(cell.row.original.date); // convert here
    //     const [d] = ist.split(","); // extract date part
    //     return <span>{d}</span>;
    //   },
    // }),
    //     columnHelper.accessor("time", {
    //       header: "Time",
    //       size: 30,
    //       Cell: (cell) => {
    //         const ist = formatToIST(cell.row.original.date); // convert here
    //         const [, t] = ist.split(","); // extract time part
    //         return <span>{t.trim()}</span>;
    //       },
    //     }),

    // columnHelper.accessor("date", {
    //   header: "Date",
    //   size: 30,

    //   Cell: (cell) => (
    //     <span style={{ textAlign: "center" }}>
    //       {cell.row.original?.date?.split("T")[0]}
    //     </span>
    //   ),
    // }),

    columnHelper.accessor("date", {
      header: "Date",
      size: 30,
      Cell: (cell) => {
        const date = cell.row.original?.date;
        return (
          <span>
            {date ? date.split("T")[0] : "-"}
          </span>
        );
      },
    }),
    columnHelper.accessor("time", {
      header: "Time",
      size: 30,
      Cell: (cell) => {
        const date = cell.row.original?.date;
        return (
          <span>
            {date ? date.split("T")[1]?.split(".")[0] : "-"}
          </span>
        );
      },
    }),
    // columnHelper.accessor("time", {
    //   header: "Time",
    //   size: 30,
    //   Cell: (cell) => (
    //     <span style={{ textAlign: "center" }}>
    //       {cell.row.original.date.split("T")[1].split(".")[0]}
    //     </span>
    //   ),
    // }),
    //     columnHelper.accessor("createdAt", {
    //   header: "Created At",
    //   size: 30,
    //   Cell: (cell) => {
    //     const ist = formatToIST(cell.row.original.createdAt);
    //     // console.log("ist: ", ist);
    //     const [date] = ist.split(","); // extract only date
    //     return <span style={{ textAlign: "center" }}>{date}</span>;
    //     // return <span style={{ textAlign: "center" }}>{ist?.split("T")[0]}</span>;
    //   },
    // }),
    // columnHelper.accessor("created", {
    //   header: "Created Time",
    //   size: 30,
    //   Cell: (cell) => {
    //     const ist = formatToIST(cell.row.original.createdAt);
    //     const [, time] = ist.split(","); // extract only time
    //     return <span style={{ textAlign: "center" }}>{time}</span>;
    //     // return <span style={{ textAlign: "center" }}>{ist?.split("T")[1]?.split(".")[0]}</span>;
    //   },
    // }),

    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => {
        const { date } = convertUTCToISTParts(cell.row.original.createdAt);
        return <span style={{ textAlign: "center" }}>{date}</span>;
      },
    }),
    columnHelper.accessor("created", {
      header: "Created Time",
      size: 30,
      Cell: (cell) => {
        const { time } = convertUTCToISTParts(cell.row.original.createdAt);
        return <span style={{ textAlign: "center" }}>{time}</span>;
      },
    }),

    // columnHelper.accessor("createdAt", {
    //   header: "Created At",
    //   size: 30,
    //   Cell: (cell) => (
    //     <span style={{ textAlign: "center" }}>
    //       {cell.row.original.createdAt.split("T")[0]}
    //     </span>
    //   ),
    // }),
    // columnHelper.accessor("created", {
    //   header: "Created Time",
    //   size: 30,
    //   Cell: (cell) => (
    //     <span style={{ textAlign: "center" }}>
    //       {cell.row.original.createdAt.split("T")[1].split(".")[0]}
    //     </span>
    //   ),
    // }),
  ];

  //  const dbDate = new Date("2025-12-04T13:54:00.000Z");
  //  console.log("dbDate: ", dbDate);
  //        const istDbDate = new Date(dbDate.getTime() - (5.5 * 60 * 60 * 1000));
  //        console.log("istDbDate: ", istDbDate);
  //         const now = new Date();
  //         console.log("now: ", now);

  //         if (istDbDate > now) {
  //           console.log("istDbDate is in the future");
  //         } else {
  //           console.log("istDbDate is in the past");
  // //         }
  // const dbDate = new Date("2025-12-04T16:05:00.000Z");
  // const now = new Date();
  // const newDDate = new Date(now.getTime() + (5.5 * 60 * 60 * 1000));


  // console.log("dbDate:", dbDate);
  // console.log("now:", now);
  // console.log("newDDate:", newDDate);

  // if (dbDate > now) {
  //   console.log("dbDate is in the future");
  // } else {
  //   console.log("dbDate is in the past");
  // }


  if (roleResponse?.Notification?.delete === 1) {
    columns.push(
      columnHelper.accessor("Actions", {
        header: "Actions",
        size: 30,
        Cell: ({ cell }) => {
          const rowId = cell.row.original._id;
          const rowData = cell.row.original;
          const status = cell.row.original?.status;
          const is_deleted = cell.row.original?.is_deleted;
          const dbDate = new Date(cell.row.original?.date);
          const now = new Date();
          const newDate = new Date(now.getTime() + (5.5 * 60 * 60 * 1000));
          // console.log("dbDate: ", dbDate);
          // console.log("now: ", now);

          return (
            <Box>
              {roleResponse?.Notification?.delete === 1 &&
                status == "scheduled" &&
                is_deleted == 0 &&
                dbDate > newDate && (
                  <Tooltip title="Delete Scheduled Notification">
                    <IconButton
                      onClick={async () => {
                        const result = await Swal.fire({
                          title: "Are you sure?",
                          text: "You will not be able to recover this Notification!",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#4d16a4",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Yes, delete it!",
                        });
                        if (result.isConfirmed) {
                          handleDelete(rowId, "/adminDeleteNotification");
                          // setRefresh(!refresh);
                          dispatch(notificationApi(queryParams));
                          Swal.fire(
                            "Deleted!",
                            "Your Notification has been deleted.",
                            "success"
                          );
                        }
                      }}
                    >
                      <DeleteIcon color="red" />
                    </IconButton>
                  </Tooltip>
                )}
              {roleResponse?.Notification?.delete === 1 &&
                status == "scheduled" &&
                is_deleted == 1 &&
                (

                  <span style={{ color: "red" }}>deleted</span>

                )}

            </Box>
          );
        },
      })
    );
  }

  const formShowHandler = (e) => {
    e.preventDefault();
    setShowForm(false);
  };

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const [showUsersList, setshowUsersList] = useState([]);
  const handleCopy = () => {
    navigator.clipboard.writeText(showUsersList.join(", "));
    toast.success("copied to clipboard!");
  };
  return (
    <>
      {/* */}
      {showForm && roleResponse?.Notification?.write === 1 && (
        <Grid item xs={12} md={6} lg={3} sx={{ mb: 2 }}>
          <Button
            onClick={formShowHandler}
            variant="contained"
            sx={{
              backgroundColor: "#4a2a7d",
              color: "white !important",
              "&:hover": {
                backgroundColor: "#4a2a7d",
              },
            }}
          >
            Notification +
          </Button>
        </Grid>
      )}
      {!showForm && (
        <Card>
          <CardContent sx={{ mb: 3 }}>
            <Box sx={{ mb: 4 }}>
              <form>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                  <Grid item xs={12} sm={6} md={4}>
                    <InputLabel htmlFor="title">
                      Title <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <TextField
                      required
                      fullWidth
                      size="small"
                      type="text"
                      id="title"
                      name="title"
                      value={formData.title}
                      onChange={handleChange}
                      error={!!formErrors.title}
                      helperText={formErrors.title}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <InputLabel htmlFor="image">Image</InputLabel>
                    <TextField
                      // required
                      fullWidth
                      size="small"
                      type="file"
                      id="image"
                      name="image"
                      onChange={handleChange}
                    // error={!!formErrors.image}
                    // helperText={formErrors.image}
                    />

                    {fileError ? <FormHelperText error  >
                      {fileError}
                    </FormHelperText> : <FormHelperText  >
                      Allowed file type {allowedExtensions.map((format) => `.${format}`).join(", ")} with max size {maxSize / (1024 * 1024)} MB
                    </FormHelperText>
                    }
                    {/* <div></div>
                    <FormHelperText  >
                      Upload an image smaller than 300 KB.
                    </FormHelperText>
                       */}

                  </Grid>
                  <Grid item xs={12} sm={6} md={4} sx={{ p: 0 }}>
                    <InputLabel htmlFor="Users">
                      Users <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Autocomplete
                      multiple
                      id="Users"
                      name="customerRefNos"
                      options={dataForUserSelection}
                      getOptionLabel={(option) => option?.name || option?.phone}
                      isOptionEqualToValue={(option, value) =>
                        option._id === value._id || option.name === value.name
                      }
                      onChange={handleUsersChange}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox
                            style={{ marginRight: 8 }}
                            checked={
                              option.name === "Select All"
                                ? formData.customerRefNos.length ===
                                dataForUserSelection.length - 1
                                : selected
                            }
                          />
                          {option.name} {option.phone}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          sx={{
                            width: "100%", // Adjust width
                            ".MuiAutocomplete-input": {
                              height: "6px", // Adjust height
                              border: "none",
                            },
                          }}
                          error={!!formErrors.customerRefNos}
                          helperText={formErrors.customerRefNos}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <InputLabel htmlFor="description">Description</InputLabel>
                    <TextField
                      required
                      multiline
                      minRows={3}
                      maxRows={10}
                      name="description"
                      id="description"
                      value={formData.description}
                      onChange={handleChange}
                      variant="outlined"
                      fullWidth
                    // error={!!formErrors.description}
                    // helperText={formErrors.description}
                    />
                    {/* <span style={{ color: "#f11517", fontSize: "13px" }}>
                      Note, Description is required at scheduled time.
                    </span> */}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    sx={{
                      display:
                        formData?.scheduling === "Scheduled" ? "block" : "none",
                    }} // Conditionally show or hide
                  >
                    <InputLabel htmlFor="date">Scheduled Date</InputLabel>
                    <TextField
                      fullWidth
                      size="small"
                      type="date"
                      id="date"
                      name="date"
                      value={formData.date}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }} // Ensures label is always visible
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    sx={{
                      display:
                        formData?.scheduling === "Scheduled" ? "block" : "none",
                    }} // Conditionally show or hide
                  >
                    <InputLabel htmlFor="time">Scheduled Time</InputLabel>
                    <TextField
                      fullWidth
                      size="small"
                      type="time"
                      id="time"
                      name="time"
                      value={formData.time}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }} // Ensures label is always visible
                    />
                    <span style={{ color: "#f11517", fontSize: "13px" }}>
                      Please add schedule time after 15 minutes from present
                      time, otherwise it will not work properly.{" "}
                    </span>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <InputLabel htmlFor="scheduling">Schedule</InputLabel>
                    <Checkbox
                      id="scheduling"
                      name="scheduling"
                      checked={formData?.scheduling === "Scheduled"}
                      onChange={handleChange}
                      color="primary"
                    />
                  </Grid>
                </Grid>

                <Box>
                  <Button
                    onClick={(e) => {
                      e.preventDefault();
                      setShowForm(true);
                    }}
                    variant="contained"
                    sx={{
                      float: "left",
                      backgroundColor: "#4a2a7d",
                      color: "white !important",
                      "&:hover": {
                        backgroundColor: "#4a2a7d",
                      },
                    }}
                  >
                    Back
                  </Button>
                  <Button
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubmit(e);
                    }}
                    variant="contained"
                    sx={{
                      float: "right",
                      backgroundColor: "#4a2a7d",
                      color: "white !important",
                      "&:hover": {
                        backgroundColor: "#4a2a7d",
                      },
                    }}
                  >
                    Send
                  </Button>
                </Box>
              </form>
            </Box>
          </CardContent>
        </Card>
      )}
      {/* table */}
      {showForm && (
        <>
          <Box>
            {/* {sliceResponseNotification && ( */}
            <>
              <DateSearchComponent onSearch={handleSearch} />
              <Box mt={2}>
                <NotificationTable
                  columns={columns}
                  // data={tableData}
                  data={sliceResponseNotification}
                  loading={stateLoading}
                  // sendData={}
                  permissionKey="Notification"
                />
              </Box>
            </>
            {/* )} */}
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 300,
                  bgcolor: "background.paper",
                  // border: "2px solid #000",
                  boxShadow: 24,
                  p: "0px 5px 10px 15px",
                  borderRadius: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    // justifyContent: "flex-end",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box>
                    <Typography>{showUsersList.length} Users</Typography>
                  </Box>

                  <Box>
                    <Tooltip title="Copy All Users">
                      <IconButton onClick={handleCopy}>
                        <ContentCopy />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Close">
                      <IconButton onClick={handleClose}>
                        <IoMdClose />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
                <Box sx={{ maxHeight: 300, overflowY: "auto" }}>
                  {showUsersList?.map((user) => (
                    <Typography key={user}>{user}</Typography>
                  ))}
                </Box>
              </Box>
            </Modal>
          </Box>
        </>
      )}
    </>
  );
}
